// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"167":"defd21ab","589":"f7a10c06"}[chunkId] + ".css";
};